module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.43a4f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/fullscreen-image_hero_600.png
// module id = SrK5
// module chunks = 0